import { TiFlowSwitch } from "react-icons/ti";

export default PipelineListEmpty;

function PipelineListEmpty() {
  return (
    <div className="flex h-[40dvh] w-full items-center justify-center mx-auto border rounded-lg">
      <div className="flex flex-col items-center">
        <TiFlowSwitch className="size-10 mr-1 text-gray-500" />
        <p className="font-medium text-md text-gray-500">No Pipelines</p>
      </div>
    </div>
  );
}
